export default __webpack_public_path__ + "static/media/QuoteOpen.18737b6e.svg";